import * as React from "react";
import { Controller, useFormContext } from "react-hook-form";
import FormHelperText from "@mui/material/FormHelperText";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from 'dayjs/plugin/timezone';
import { Box, Typography } from "@mui/material";

dayjs.extend(utc);
dayjs.extend(timezone);

const FormDateTimePicker = ({ name, control, label, rules, timezone, disabled }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field, fieldState }) => (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 12, p: 2 }}>
            <Typography sx={{ p: 1, minWidth: 256 }}>{label}</Typography>
            <DateTimePicker
              {...field}
              slotProps={{
                textField: { size: "small", error: !!fieldState.error, sx: { width: 384, height: 40 } },
              }}
              format="YYYY-MM-DDTHH:mm:ss"
              autoOk
              timezone={timezone || "UTC"}
              disablePast
              error={!!field.error}
              disabled={disabled}
            />
            <FormHelperText sx={{ color: 'error.main', ml: 2 }}>{fieldState.error?.message}</FormHelperText>
          </Box>
        )}
      />
    </LocalizationProvider>
  );
};

export default FormDateTimePicker;
